import { authGet, authPost } from './apiService';

/**
 * Backup & Restore (MongoDB) – uses server persistent mount.
 */
export const backupRestoreService = {
  listBackups: () => authGet('/api/admin/backup-restore/list'),
  createBackup: (name) => authPost('/api/admin/backup-restore/backup', { name }),
  restoreBackup: (name) => authPost('/api/admin/backup-restore/restore', { name })
};
